import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'react-bootstrap';

export const EmptyList = ({ onCreateReport }) => (
  <div className="tvt-my-reports__empty-list">
    <FontAwesomeIcon icon="file-alt" size="4x" />
    <p>You have no reports created.</p>
    <p>Create a custom report in the report builder to see it listed here!</p>
    <Button onClick={onCreateReport}>Create a Report</Button>
  </div>
);

EmptyList.propTypes = {
  onCreateReport: PropTypes.func.isRequired
};

export default EmptyList;
